'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var _excluded = ["light", "upper", "className", "Elm"],
    _excluded2 = ["serif", "className", "Elm"],
    _excluded3 = ["serif", "className", "Elm"],
    _excluded4 = ["serif", "className", "Elm"],
    _excluded5 = ["className", "Elm"];
var Headline1 = function Headline1(_ref) {
  var _classnames;

  var light = _ref.light,
      upper = _ref.upper,
      className = _ref.className,
      _ref$Elm = _ref.Elm,
      Elm = _ref$Elm === void 0 ? 'h1' : _ref$Elm,
      rProps = _objectWithoutProperties(_ref, _excluded);

  var baseClass = 'b-headline-1';
  var headingClass = classnames(baseClass, (_classnames = {}, _defineProperty(_classnames, "".concat(baseClass, "--upper"), upper), _defineProperty(_classnames, "".concat(baseClass, "--light"), light), _classnames), className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: headingClass
  }, rProps));
};
var Headline2 = function Headline2(_ref2) {
  var serif = _ref2.serif,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$Elm = _ref2.Elm,
      Elm = _ref2$Elm === void 0 ? 'h2' : _ref2$Elm,
      rProps = _objectWithoutProperties(_ref2, _excluded2);

  var baseClass = 'b-headline-2';
  var headingClass = classnames(baseClass, _defineProperty({}, "".concat(baseClass, "--serif"), serif), className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: headingClass
  }, rProps));
};
var Headline3 = function Headline3(_ref3) {
  var serif = _ref3.serif,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$Elm = _ref3.Elm,
      Elm = _ref3$Elm === void 0 ? 'h3' : _ref3$Elm,
      rProps = _objectWithoutProperties(_ref3, _excluded3);

  var baseClass = 'b-headline-3';
  var headingClass = classnames(baseClass, _defineProperty({}, "".concat(baseClass, "--serif"), serif), className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: headingClass
  }, rProps));
};
var Headline4 = function Headline4(_ref4) {
  var serif = _ref4.serif,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      _ref4$Elm = _ref4.Elm,
      Elm = _ref4$Elm === void 0 ? 'h4' : _ref4$Elm,
      rProps = _objectWithoutProperties(_ref4, _excluded4);

  var baseClass = 'b-headline-4';
  var headingClass = classnames(baseClass, _defineProperty({}, "".concat(baseClass, "--serif"), serif), className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: headingClass
  }, rProps));
};
var Eyebrow = function Eyebrow(_ref5) {
  var _ref5$className = _ref5.className,
      className = _ref5$className === void 0 ? '' : _ref5$className,
      _ref5$Elm = _ref5.Elm,
      Elm = _ref5$Elm === void 0 ? "div" : _ref5$Elm,
      rProps = _objectWithoutProperties(_ref5, _excluded5);

  var baseClass = 'b-eyebrow';
  var eyebrowClass = classnames(baseClass, className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: eyebrowClass
  }, rProps));
};

var typography = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Headline1: Headline1,
  Headline2: Headline2,
  Headline3: Headline3,
  Headline4: Headline4,
  Eyebrow: Eyebrow
});

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = toggleSelection();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

var copyToClipboard = copy;

var FileSaver_min = createCommonjsModule(function (module, exports) {
(function(a,b){b();})(commonjsGlobal,function(){function b(a,b){return "undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c);},d.onerror=function(){console.error("could not download file");},d.send();}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send();}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"));}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b);}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof commonjsGlobal&&commonjsGlobal.global===commonjsGlobal?commonjsGlobal:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href);},4E4),setTimeout(function(){e(j);},0));}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else {var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i);});}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null;},k.readAsDataURL(b);}else {var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m);},4E4);}});f.saveAs=g.saveAs=g,(module.exports=g);});


});

var _excluded$1 = ["className", "children"],
    _excluded2$1 = ["className", "children", "iconUrl", "reverse"],
    _excluded3$1 = ["alt", "fileSrc", "fileName", "thumbnailSrc", "forceDownload", "className"],
    _excluded4$1 = ["pageUrl", "pageTitle", "socialOutlet", "className"];
var Button = function Button(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var Elm = props.Elm || (props.href ? 'a' : 'button');
  var baseClass = 'c-btn';
  var btnClass = classnames(baseClass, className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: btnClass
  }, props), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(baseClass, "__txt")
  }, children));
};
var ctaBaseClass = 'c-cta';

var CtaIcon = function CtaIcon(_ref2) {
  var iconUrl = _ref2.iconUrl;
  if (!iconUrl) return null;
  return /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(ctaBaseClass, "__icon"),
    src: iconUrl,
    alt: ""
  });
};

var Cta = function Cta(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      iconUrl = _ref3.iconUrl,
      reverse = _ref3.reverse,
      props = _objectWithoutProperties(_ref3, _excluded2$1);

  var Elm = props.Elm || (props.href ? 'a' : 'button');
  var ctaClass = classnames(ctaBaseClass, _defineProperty({}, "".concat(ctaBaseClass, "--reverse"), reverse), className);
  return /*#__PURE__*/React__default['default'].createElement(Elm, _extends({
    className: ctaClass
  }, props), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-txt-btn ".concat(ctaBaseClass, "__txt")
  }, children), /*#__PURE__*/React__default['default'].createElement(CtaIcon, {
    iconUrl: iconUrl
  }));
};
var DownloadBtn = function DownloadBtn(_ref4) {
  var alt = _ref4.alt,
      fileSrc = _ref4.fileSrc,
      fileName = _ref4.fileName,
      thumbnailSrc = _ref4.thumbnailSrc,
      forceDownload = _ref4.forceDownload,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      rProps = _objectWithoutProperties(_ref4, _excluded3$1);

  var baseClass = "c-download";
  var downloadClass = classnames(baseClass, className);

  var handleSubmit = function handleSubmit(e) {
    if (forceDownload) {
      e.preventDefault();
      return fileName ? FileSaver_min.saveAs(fileSrc, fileName) : FileSaver_min.saveAs(fileSrc);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("a", _extends({
    className: downloadClass,
    onClick: handleSubmit,
    href: fileSrc,
    target: "_blank"
  }, rProps), /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass, "__image u-disp-block"),
    alt: alt,
    src: thumbnailSrc
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(baseClass, "__circle")
  }), /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass, "__arrow"),
    alt: "",
    src: "https://images.ctfassets.net/70w6ftfzv4je/2GxQwUMhdXiAKLgeVzPkS6/95ce6511fe60b673f2407fc37fb5d544/arrow_download.svg"
  }));
};
var SocialShareButton = function SocialShareButton(_ref5) {
  var pageUrl = _ref5.pageUrl,
      pageTitle = _ref5.pageTitle,
      socialOutlet = _ref5.socialOutlet,
      _ref5$className = _ref5.className,
      rProps = _objectWithoutProperties(_ref5, _excluded4$1);

  var baseClass = "c-social";
  var socialOutletResolver = {
    LinkedIn: {
      href: "https://www.linkedin.com/shareArticle?url=".concat(pageUrl, "&title=").concat(pageTitle),
      icon: "https://images.ctfassets.net/70w6ftfzv4je/3l05PCFsfkuO0E69ODrskz/9a3374c46d1533075d68587179f92256/LinkedinSVG.svg"
    },
    Twitter: {
      href: "https://twitter.com/share?url=".concat(pageUrl, "&text=").concat(pageTitle),
      icon: "https://images.ctfassets.net/2in405srp47m/2eokXNX8ZjfUHplOUFMTCb/3f4663389f7d29eaf6d108e8ab1adb00/twitterSvg.svg"
    },
    Facebook: {
      href: "https://www.facebook.com/sharer/sharer.php?u=".concat(pageUrl),
      icon: "https://images.ctfassets.net/70w6ftfzv4je/4TWTVGhErTrzu6Pqa86Iu/3db9ce4c262a9d317b7b5a377e913615/social_fb.svg"
    }
  };
  var socialProps = socialOutletResolver[socialOutlet];

  if (!socialProps) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("a", _extends({
    className: "".concat(baseClass),
    href: socialProps.href,
    target: "blank"
  }, rProps), /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass, "__button"),
    src: socialProps.icon,
    alt: socialOutlet
  }));
};
var CopyToClipboard = function CopyToClipboard(className) {
  var baseClass = "c-social";
  var iconLink = "https://images.ctfassets.net/70w6ftfzv4je/5C1XXVO5g27moEkfCWLWCW/ffd9fc8936f9adabbc197186d3e30c9d/copyLink_icon.svg";

  function copyLink() {
    copyToClipboard(document.location.href);
  }

  return /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare ".concat(baseClass),
    onClick: copyLink
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass, "__button"),
    src: iconLink,
    alt: "Copy Button"
  }));
};

var buttons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Button: Button,
  Cta: Cta,
  DownloadBtn: DownloadBtn,
  SocialShareButton: SocialShareButton,
  CopyToClipboard: CopyToClipboard
});

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

var _excluded$2 = ["topicTitle", "topicUrl", "articleTitle", "articleUrl", "authorName", "target", "authorUrl", "imageUrl", "imageAlt", "HeadingElm", "width", "height"],
    _excluded2$2 = ["eyebrowTitle", "articleTitle", "articleUrl", "date", "imageUrl", "imageAlt", "HeadingElm", "width", "height", "target"];
var baseClassName = 'c-story';

var InsightsImage = function InsightsImage(_ref) {
  var imageUrl = _ref.imageUrl,
      target = _ref.target,
      isHovered = _ref.isHovered,
      imageAlt = _ref.imageAlt,
      articleUrl = _ref.articleUrl,
      width = _ref.width,
      height = _ref.height,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  if (!imageUrl) {
    return null;
  }

  var wrapperClass = classnames('b-bare', "".concat(baseClassName, "__img-wrap"));
  var imgClass = classnames("".concat(baseClassName, "__img"), _defineProperty({}, "".concat(baseClassName, "__img--hover"), isHovered));
  var sizeProps = {};
  if (width) sizeProps.width = width;
  if (height) sizeProps.height = height;
  return /*#__PURE__*/React__default['default'].createElement("a", {
    href: articleUrl,
    target: target,
    className: wrapperClass,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React__default['default'].createElement("img", _extends({
    className: imgClass,
    src: imageUrl
  }, sizeProps, {
    alt: imageAlt
  })));
};

var getFlag = function getFlag(_ref2) {
  var featured = _ref2.featured,
      large = _ref2.large,
      stacked = _ref2.stacked,
      imageUrl = _ref2.imageUrl;
  if (!imageUrl) return 'no-image';
  if (featured) return 'featured';
  if (large) return 'large';
  if (stacked) return 'stacked';
  return 'small';
};

var InsightStoryAuthor = function InsightStoryAuthor(_ref3) {
  var authorName = _ref3.authorName,
      authorUrl = _ref3.authorUrl;
  if (!authorName) return null;
  var Elm = authorUrl ? function (p) {
    return /*#__PURE__*/React__default['default'].createElement("a", _extends({
      href: authorUrl
    }, p));
  } : 'span';
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: "u-color-grey-4a u-fs-italic"
  }, "By", ' ', /*#__PURE__*/React__default['default'].createElement(Elm, {
    className: "b-bare ".concat(baseClassName, "__author")
  }, authorName));
};

var TopicEyebrow = function TopicEyebrow(_ref4) {
  var topicTitle = _ref4.topicTitle,
      topicUrl = _ref4.topicUrl;
  if (!topicTitle) return null;
  if (!topicUrl) return /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-txt-btn u-disp-block u-color-blue"
  }, topicTitle);
  return /*#__PURE__*/React__default['default'].createElement(Cta, {
    href: topicUrl
  }, topicTitle);
};

var InsightStory = function InsightStory(_ref5) {
  var topicTitle = _ref5.topicTitle,
      topicUrl = _ref5.topicUrl,
      articleTitle = _ref5.articleTitle,
      articleUrl = _ref5.articleUrl,
      authorName = _ref5.authorName,
      _ref5$target = _ref5.target,
      target = _ref5$target === void 0 ? "_self" : _ref5$target,
      authorUrl = _ref5.authorUrl,
      imageUrl = _ref5.imageUrl,
      imageAlt = _ref5.imageAlt,
      _ref5$HeadingElm = _ref5.HeadingElm,
      HeadingElm = _ref5$HeadingElm === void 0 ? "h3" : _ref5$HeadingElm,
      width = _ref5.width,
      height = _ref5.height,
      rProps = _objectWithoutProperties(_ref5, _excluded$2);

  var flag = getFlag(_objectSpread2(_objectSpread2({}, rProps), {}, {
    imageUrl: imageUrl
  }));
  var headingComponentResolver = {};
  headingComponentResolver['featured'] = Headline2;
  headingComponentResolver['large'] = Headline3;
  headingComponentResolver['small'] = Headline4;
  headingComponentResolver['stacked'] = Headline4;
  headingComponentResolver['no-image'] = Headline4;
  var ArticleTitleElm = headingComponentResolver[flag];

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var handleMouseLeave = function handleMouseLeave() {
    return setIsHovered(false);
  };

  var handleMouseEnter = function handleMouseEnter() {
    return setIsHovered(true);
  };

  var articleClass = classnames(baseClassName, "".concat(baseClassName, "--").concat(flag));
  var textClass = classnames("".concat(baseClassName, "__text"), _defineProperty({}, "".concat(baseClassName, "__text--hover"), isHovered && flag === 'featured'));
  var titleClass = classnames('b-bare', "".concat(baseClassName, "__title"), _defineProperty({}, "".concat(baseClassName, "__title--hover"), isHovered));
  return /*#__PURE__*/React__default['default'].createElement("article", {
    className: articleClass
  }, /*#__PURE__*/React__default['default'].createElement(InsightsImage, {
    imageUrl: imageUrl,
    target: target,
    imageAlt: imageAlt,
    articleUrl: articleUrl,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    isHovered: isHovered,
    width: width,
    height: height
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: textClass
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "b-bare"
  }, /*#__PURE__*/React__default['default'].createElement(TopicEyebrow, {
    topicUrl: topicUrl,
    topicTitle: topicTitle
  }), /*#__PURE__*/React__default['default'].createElement("a", {
    className: titleClass,
    target: target,
    href: articleUrl,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React__default['default'].createElement(ArticleTitleElm, {
    serif: true,
    className: "u-disp-block u-mar-vt-20",
    Elm: HeadingElm
  }, articleTitle))), /*#__PURE__*/React__default['default'].createElement(InsightStoryAuthor, {
    authorName: authorName,
    authorUrl: authorUrl
  })));
};
var PressStory = function PressStory(_ref6) {
  var eyebrowTitle = _ref6.eyebrowTitle,
      articleTitle = _ref6.articleTitle,
      articleUrl = _ref6.articleUrl,
      date = _ref6.date,
      imageUrl = _ref6.imageUrl,
      imageAlt = _ref6.imageAlt,
      _ref6$HeadingElm = _ref6.HeadingElm,
      HeadingElm = _ref6$HeadingElm === void 0 ? "h3" : _ref6$HeadingElm,
      width = _ref6.width,
      height = _ref6.height,
      _ref6$target = _ref6.target,
      target = _ref6$target === void 0 ? "_self" : _ref6$target,
      rProps = _objectWithoutProperties(_ref6, _excluded2$2);

  var flag = getFlag(_objectSpread2(_objectSpread2({}, rProps), {}, {
    imageUrl: imageUrl
  }));
  var headingComponentResolver = {};
  headingComponentResolver['featured'] = Headline2;
  headingComponentResolver['large'] = Headline3;
  headingComponentResolver['small'] = Headline4;
  headingComponentResolver['stacked'] = Headline4;
  headingComponentResolver['no-image'] = Headline4;
  var publishDate = moment(date).format("MMMM D, YYYY");
  var ArticleTitleElm = headingComponentResolver[flag];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  var handleMouseLeave = function handleMouseLeave() {
    return setIsHovered(false);
  };

  var handleMouseEnter = function handleMouseEnter() {
    return setIsHovered(true);
  };

  var articleClass = classnames(baseClassName, "".concat(baseClassName, "--").concat(flag));
  var textClass = classnames("".concat(baseClassName, "__text"), _defineProperty({}, "".concat(baseClassName, "__text--hover"), isHovered && flag === 'featured'));
  var titleClass = classnames('b-bare', "".concat(baseClassName, "__title"), _defineProperty({}, "".concat(baseClassName, "__title--hover"), isHovered));
  return /*#__PURE__*/React__default['default'].createElement("article", {
    className: articleClass
  }, /*#__PURE__*/React__default['default'].createElement(InsightsImage, {
    imageUrl: imageUrl,
    target: target,
    imageAlt: imageAlt,
    articleUrl: articleUrl,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    isHovered: isHovered,
    width: width,
    height: height
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: textClass
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "b-bare"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-txt-btn u-disp-block u-color-blue"
  }, eyebrowTitle), /*#__PURE__*/React__default['default'].createElement("a", {
    className: titleClass,
    target: target,
    href: articleUrl,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React__default['default'].createElement(ArticleTitleElm, {
    serif: true,
    className: "u-disp-block u-mar-vt-20",
    Elm: HeadingElm
  }, articleTitle))), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-byline u-color-grey-61 u-fs-italic"
  }, publishDate)));
};
var storyGridClass = 'o-story-grid';
var StoryGrid = function StoryGrid(_ref7) {
  var children = _ref7.children,
      variant = _ref7.variant;
  var gridClassName = classnames(storyGridClass, _defineProperty({}, "".concat(storyGridClass, "--").concat(variant), variant));
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: gridClassName
  }, children);
};

StoryGrid.Cell = function (props) {
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: "".concat(storyGridClass, "__cell")
  }, props));
};

var stories = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InsightStory: InsightStory,
  PressStory: PressStory,
  StoryGrid: StoryGrid
});

var baseClass = 'c-author';

var Bio = function Bio(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return children ? /*#__PURE__*/React__default['default'].createElement("p", {
    className: className
  }, children) : null;
};

var NameLink = function NameLink(props) {
  return /*#__PURE__*/React__default['default'].createElement("a", _extends({
    className: "b-bare o-underline-hover"
  }, props));
};

var AuthorLink = function AuthorLink(props) {
  var Elm = props.href ? NameLink : React__default['default'].Fragment;
  return /*#__PURE__*/React__default['default'].createElement(Elm, props);
};

var Img = function Img(_ref2) {
  var imageSrc = _ref2.imageSrc,
      href = _ref2.href,
      fullName = _ref2.fullName;
  if (!imageSrc) return null;
  var Wrap = href ? 'a' : 'div';
  return /*#__PURE__*/React__default['default'].createElement(Wrap, {
    className: "b-bare ".concat(baseClass, "__img-wrap"),
    href: href
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass, "__img"),
    src: imageSrc,
    alt: fullName
  }));
};

var LinkedIn = function LinkedIn(_ref3) {
  var linkedInProfile = _ref3.linkedInProfile;
  var baseClass = "c-social";
  if (!linkedInProfile) return null;
  var icon = "https://images.ctfassets.net/2in405srp47m/1VEaaGJYZOiNwYbTWaJ7aJ/21af519e7bb46f6dd779e7359cb56750/linkedin-icon.svg";
  return /*#__PURE__*/React__default['default'].createElement("a", {
    className: "b-bare ".concat(baseClass),
    href: linkedInProfile,
    target: "blank"
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass, "__button"),
    src: icon,
    alt: ""
  }));
};
var Author = function Author(_ref4) {
  var _classnames;

  var href = _ref4.href,
      fullName = _ref4.fullName,
      jobTitle = _ref4.jobTitle,
      imageSrc = _ref4.imageSrc,
      children = _ref4.children,
      large = _ref4.large,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? "" : _ref4$className;
  var authorClass = classnames(baseClass, (_classnames = {}, _defineProperty(_classnames, "".concat(baseClass, "--large"), large), _defineProperty(_classnames, 'u-disp-block', !imageSrc), _classnames), className);
  var nameClass = classnames('b-body', 'b-body--serif', _defineProperty({}, "b-body--small", !large), 'u-disp-block');
  var titleClass = classnames('b-body', 'b-body--serif', _defineProperty({}, "b-body--small", !large), 'u-color-grey-4a', 'u-fs-italic', 'u-disp-block');
  var bioClass = classnames('b-body', _defineProperty({}, "b-body--small", !large), 'u-fw-light', 'u-mar-top-10', 'u-mar-bottom-0');
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: authorClass
  }, /*#__PURE__*/React__default['default'].createElement(Img, {
    imageSrc: imageSrc,
    href: href,
    fullName: fullName
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass, "__content")
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: nameClass
  }, /*#__PURE__*/React__default['default'].createElement(AuthorLink, {
    href: href
  }, fullName)), /*#__PURE__*/React__default['default'].createElement("span", {
    className: titleClass
  }, jobTitle), /*#__PURE__*/React__default['default'].createElement(Bio, {
    className: bioClass
  }, children)));
};

var authors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LinkedIn: LinkedIn,
  Author: Author
});

var _excluded$3 = ["children", "name", "title", "long", "removeQuotations", "className"];
var Quote = function Quote(_ref) {
  var _classnames2;

  var children = _ref.children,
      name = _ref.name,
      title = _ref.title,
      _long = _ref["long"],
      removeQuotations = _ref.removeQuotations,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rProps = _objectWithoutProperties(_ref, _excluded$3);

  var baseClass = "o-quote";
  var quoteClass = classnames('b-bare', baseClass, _defineProperty({}, "".concat(baseClass, "--long"), _long), className);
  var quoteTextClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, "".concat(baseClass, "__text"), !removeQuotations), _defineProperty(_classnames2, "u-color-blue", !_long), _defineProperty(_classnames2, "u-color-grey-4a", _long), _classnames2));
  var TextElm = _long ? 'div' : function (p) {
    return /*#__PURE__*/React__default['default'].createElement(Headline3, _extends({
      serif: true,
      Elm: "div"
    }, p));
  };
  return /*#__PURE__*/React__default['default'].createElement("blockquote", _extends({
    className: quoteClass
  }, rProps), /*#__PURE__*/React__default['default'].createElement(TextElm, {
    className: quoteTextClass
  }, children), /*#__PURE__*/React__default['default'].createElement("cite", {
    className: "b-bare b-body b-body--small u-color-grey-4a u-mar-top-20 u-disp-block"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "u-tt-upper u-fw-medium"
  }, " ", name, " "), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "u-fw-light"
  }, " ", title, " ")));
};

var quotes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Quote: Quote
});

var _excluded$4 = ["children", "className"],
    _excluded2$3 = ["className"],
    _excluded3$2 = ["className"];
var baseClass$1 = "o-figure";
var Figure = function Figure(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rProps = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React__default['default'].createElement("figure", _extends({
    className: "b-bare ".concat(baseClass$1, " ").concat(className).trim()
  }, rProps), children);
};

Figure.Image = function (_ref2) {
  var className = _ref2.className,
      rProps = _objectWithoutProperties(_ref2, _excluded2$3);

  return /*#__PURE__*/React__default['default'].createElement("img", _extends({
    className: "u-width-100 ".concat(className).trim()
  }, rProps));
};

Figure.Video = function (_ref3) {
  var className = _ref3.className,
      rProps = _objectWithoutProperties(_ref3, _excluded3$2);

  return /*#__PURE__*/React__default['default'].createElement("video", _extends({
    className: "u-width-100 ".concat(className).trim()
  }, rProps, {
    autoPlay: false,
    preload: true
  }));
};

Figure.Caption = function (_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React__default['default'].createElement("figcaption", {
    className: "b-caption ".concat(baseClass$1, "__caption")
  }, children);
};

Figure.Slider = function (_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React__default['default'].createElement("figcaption", {
    className: "b-caption ".concat(baseClass$1, "__caption ").concat(baseClass$1, "__caption--slider")
  }, children);
};

var figures = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Figure: Figure
});

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let nanoid = (size = 21) => {
  let id = '';
  let i = size;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id
};

var _excluded$5 = ["value", "setValue", "defaultValue", "label", "children", "id", "hasBackground", "type", "onChange", "onFocus", "onBlur"];
var baseClass$2 = 'c-textbox';

var ef = function ef() {};

var HelpText = function HelpText(_ref) {
  var children = _ref.children,
      id = _ref.id;
  if (!children) return null;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "".concat(id, "_helptext"),
    className: "b-caption ".concat(baseClass$2, "__help u-mar-top-10")
  }, children);
};

var Textbox = function Textbox(_ref2) {
  var value = _ref2.value,
      setValue = _ref2.setValue,
      _ref2$defaultValue = _ref2.defaultValue,
      defaultValue = _ref2$defaultValue === void 0 ? '' : _ref2$defaultValue,
      label = _ref2.label,
      children = _ref2.children,
      id = _ref2.id,
      hasBackground = _ref2.hasBackground,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'text' : _ref2$type,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? ef : _ref2$onChange,
      _ref2$onFocus = _ref2.onFocus,
      onFocus = _ref2$onFocus === void 0 ? ef : _ref2$onFocus,
      _ref2$onBlur = _ref2.onBlur,
      onBlur = _ref2$onBlur === void 0 ? ef : _ref2$onBlur,
      rProps = _objectWithoutProperties(_ref2, _excluded$5);

  var _useState = React.useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledValue = _useState2[0],
      setUncontrolledValue = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasFocus = _useState4[0],
      setHasFocus = _useState4[1];

  var textboxId = React.useRef(id || nanoid());
  var fieldValue = value !== null && value !== void 0 ? value : uncontrolledValue;
  var setFieldValue = setValue !== null && setValue !== void 0 ? setValue : setUncontrolledValue;
  var hasHelpText = !!children;

  var handleChange = function handleChange(event) {
    var _event$target;

    setFieldValue(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    onChange();
  };

  var handleFocus = function handleFocus() {
    setHasFocus(true);
    onFocus();
  };

  var handleBlur = function handleBlur() {
    setHasFocus(false);
    onBlur();
  };

  var textboxClass = classnames("b-body", baseClass$2, _defineProperty({}, "".concat(baseClass$2, "--has-background"), hasBackground));
  var labelClass = classnames(" ".concat(baseClass$2, "__label"), _defineProperty({}, "".concat(baseClass$2, "__label--float"), hasFocus || !!fieldValue));

  var inputProps = _objectSpread2({
    className: "b-bare ".concat(baseClass$2, "__field"),
    type: type,
    id: "".concat(textboxId.current, "_field"),
    value: fieldValue,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    'aria-describedby': hasHelpText ? "".concat(textboxId.current, "_helptext") : null,
    pattern: type === 'email' ? "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" : null
  }, rProps);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: textboxClass
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: "".concat(textboxId.current, "_field"),
    className: labelClass
  }, label), /*#__PURE__*/React__default['default'].createElement("input", inputProps), /*#__PURE__*/React__default['default'].createElement(HelpText, {
    id: textboxId.current
  }, children));
};

var textbox = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Textbox: Textbox
});

var _excluded$6 = ["className"],
    _excluded2$4 = ["className"];
var baseClass$3 = 'c-footer';

var FooterLink = function FooterLink(_ref) {
  var text = _ref.text,
      href = _ref.href;
  return /*#__PURE__*/React__default['default'].createElement("li", {
    className: "b-bare u-mar-vt-20"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: href,
    className: "".concat(baseClass$3, "__link")
  }, text));
};

var SocialLink = function SocialLink(_ref2) {
  var imageUrl = _ref2.imageUrl,
      href = _ref2.href,
      altText = _ref2.altText;
  return /*#__PURE__*/React__default['default'].createElement("li", {
    className: "b-bare ".concat(baseClass$3, "__social-item")
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: "b-bare ".concat(baseClass$3, "__icon-link"),
    href: href,
    target: "_blank"
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    src: imageUrl,
    className: "".concat(baseClass$3, "__icon"),
    alt: altText
  })));
};

var defaultCopyright = "\xA9 ".concat(new Date().getFullYear(), " CoverMyMeds LLC. All Rights Reserved.");
var Footer = function Footer(_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  var footerClass = classnames('b-body c-footer', className);
  return /*#__PURE__*/React__default['default'].createElement("footer", {
    className: footerClass
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-footer__container"
  }, children));
};

Footer.Heading = function (p) {
  return /*#__PURE__*/React__default['default'].createElement("h5", _extends({
    className: "u-fw-bold"
  }, p));
};

Footer.Copyright = function (_ref4) {
  var _ref4$children = _ref4.children,
      children = _ref4$children === void 0 ? defaultCopyright : _ref4$children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "b-attribution c-footer__copyright"
  }, children);
};

Footer.Rule = function () {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-footer__rule"
  });
};

Footer.LinkGroup = function (_ref5) {
  var title = _ref5.title,
      _ref5$linkList = _ref5.linkList,
      linkList = _ref5$linkList === void 0 ? [] : _ref5$linkList;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$3, "__link-group")
  }, /*#__PURE__*/React__default['default'].createElement(Footer.Heading, null, title), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "b-bare"
  }, linkList.map(function (link, i) {
    return /*#__PURE__*/React__default['default'].createElement(FooterLink, _extends({}, link, {
      key: i
    }));
  })));
};

Footer.SocialList = function (_ref6) {
  var _ref6$socialList = _ref6.socialList,
      socialList = _ref6$socialList === void 0 ? [] : _ref6$socialList;
  return /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "b-bare c-footer__social"
  }, socialList.map(function (sl, i) {
    return /*#__PURE__*/React__default['default'].createElement(SocialLink, _extends({}, sl, {
      key: i
    }));
  }));
};

Footer.Subscribe = function (p) {
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: "c-footer__subscribe gtm-subscribe "
  }, p));
};

Footer.Form = function (_ref7) {
  var _ref7$className = _ref7.className,
      className = _ref7$className === void 0 ? '' : _ref7$className,
      p = _objectWithoutProperties(_ref7, _excluded$6);

  return /*#__PURE__*/React__default['default'].createElement("form", _extends({
    className: "".concat(baseClass$3, "__form ").concat(className).trim()
  }, p));
};

Footer.Field = function (p) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$3, "__email")
  }, /*#__PURE__*/React__default['default'].createElement(Textbox, _extends({
    hasBackground: true
  }, p)));
};

Footer.Submit = function (_ref8) {
  var className = _ref8.className,
      p = _objectWithoutProperties(_ref8, _excluded2$4);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$3, "__submit")
  }, /*#__PURE__*/React__default['default'].createElement(Button, _extends({
    className: "u-width-100 ".concat(className).trim()
  }, p)));
};

var footer = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Footer: Footer
});

var _excluded$7 = ["isCta", "linkList"];
var baseClass$4 = 'c-nav';
var hamburgerBaseClass = 'c-hamburger';

var NavLink = function NavLink(_ref) {
  var label = _ref.label,
      href = _ref.href,
      isLast = _ref.isLast;
  return /*#__PURE__*/React__default['default'].createElement("a", {
    className: "b-bare c-nav__action".concat(isLast ? ' u-mar-right-0' : ''),
    href: href
  }, label, /*#__PURE__*/React__default['default'].createElement("span", {
    "aria-hidden": "true",
    className: "c-nav__bold-spacer",
    "data-label": label
  }));
};

var NavCta = function NavCta(_ref2) {
  var label = _ref2.label,
      href = _ref2.href,
      isLast = _ref2.isLast,
      isIconUrl = _ref2.isIconUrl;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__action".concat(isLast ? ' u-mar-right-0' : '')
  }, /*#__PURE__*/React__default['default'].createElement(Cta, {
    href: href,
    iconUrl: isIconUrl ? 'https://images.ctfassets.net/70w6ftfzv4je/4KWzJ87hflPLKaBdDBJO9r/eac3053272e9d8dd84102dc3bf3c99b0/arrow-right.svg' : ""
  }, label));
};

var NavDropdown = function NavDropdown(_ref3) {
  var label = _ref3.label,
      _ref3$linkList = _ref3.linkList,
      linkList = _ref3$linkList === void 0 ? [] : _ref3$linkList,
      openSubmenu = _ref3.openSubmenu,
      setOpenSubmenu = _ref3.setOpenSubmenu,
      index = _ref3.index;
  var isOpenMenu = openSubmenu === label;
  var submenuClass = classnames('b-bare c-nav__submenu', {
    'c-nav__submenu--open': isOpenMenu
  });

  var handleClick = function handleClick() {
    setOpenSubmenu(label);
  };

  var handleMouseEnter = function handleMouseEnter() {
    setOpenSubmenu(label);
  };

  var container = React.useRef(); //.current is useref standard - use ref  creates an object and stores values - won't be updated unless we specifically update it. 
  //container.current = list item element
  //if i'm not hovering & it's open, close it. 

  var handleMouseOut = function handleMouseOut(event) {
    if (isOpenMenu && !container.current.contains(event.target)) setOpenSubmenu(null);
  };

  React.useEffect(function () {
    //adding event listener to body
    document.body.addEventListener('mouseover', handleMouseOut);
    return function () {
      document.body.removeEventListener('mouseover', handleMouseOut);
    };
  }, [isOpenMenu]);
  var submenuId = "primary-nav-submenu_".concat(index);
  return /*#__PURE__*/React__default['default'].createElement("li", {
    className: "b-bare c-nav__menu-item",
    ref: container
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare c-nav__action",
    onMouseEnter: handleMouseEnter,
    onClick: handleClick,
    "aria-controls": submenuId,
    "aria-expanded": isOpenMenu
  }, label, /*#__PURE__*/React__default['default'].createElement("span", {
    "aria-hidden": "true",
    className: "c-nav__bold-spacer",
    "data-label": label
  })), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: submenuClass,
    id: submenuId
  }, linkList.map(function (_ref4) {
    var label = _ref4.label,
        href = _ref4.href;
    return /*#__PURE__*/React__default['default'].createElement("li", {
      className: "b-bare c-nav__menu-item c-nav__menu-item--submenu",
      key: label
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      href: href,
      className: "b-bare c-nav__action c-nav__action--submenu"
    }, label));
  })));
};

var NavItem = function NavItem(_ref5) {
  var isCta = _ref5.isCta,
      linkList = _ref5.linkList,
      rProps = _objectWithoutProperties(_ref5, _excluded$7);

  if (isCta) return /*#__PURE__*/React__default['default'].createElement(NavCta, rProps);
  if (linkList) return /*#__PURE__*/React__default['default'].createElement(NavDropdown, _extends({
    linkList: linkList
  }, rProps));
  return /*#__PURE__*/React__default['default'].createElement(NavLink, rProps);
};

var InsightsNavbar = function InsightsNavbar(_ref6) {
  var _ref6$industryUrl = _ref6.industryUrl,
      industryUrl = _ref6$industryUrl === void 0 ? 'https://covermymeds.com/main' : _ref6$industryUrl,
      _ref6$insightsUrl = _ref6.insightsUrl,
      insightsUrl = _ref6$insightsUrl === void 0 ? 'https://insights.covermymeds.com/' : _ref6$insightsUrl,
      _ref6$linkList = _ref6.linkList,
      linkList = _ref6$linkList === void 0 ? [] : _ref6$linkList,
      className = _ref6.className;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var navClass = classnames("b-caption ".concat(baseClass$4, " ").concat(baseClass$4, "--insights"), _defineProperty({}, "".concat(baseClass$4, "--open"), isOpen), className);
  var hamburgerClass = classnames("b-bare ".concat(hamburgerBaseClass), _defineProperty({}, "".concat(hamburgerBaseClass, "--open"), isOpen));

  var handleHamburgerClick = function handleHamburgerClick() {
    return setIsOpen(!isOpen);
  };

  return /*#__PURE__*/React__default['default'].createElement("nav", {
    className: navClass
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$4, "__wrap")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__logo-link u-disp-flex"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: "b-bare",
    href: industryUrl
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "b-bare c-nav__logo u-disp-block",
    width: "178",
    height: "30",
    src: "https://images.ctfassets.net/70w6ftfzv4je/1oZePEp9g2zGMawzERET3t/d7ec9b3ededa68f326d52fd9c8799b32/logo-industry.svg",
    alt: "CoverMyMeds Industry Home"
  })), /*#__PURE__*/React__default['default'].createElement("a", {
    className: "b-bare",
    href: insightsUrl
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "b-bare c-nav__logo c-nav__logo--insights u-disp-block u-mar-left-10",
    width: "84",
    height: "30",
    src: "https://images.ctfassets.net/70w6ftfzv4je/49UTUWqRDaswlebMdeKNeQ/bcf919b012da6a2c325199d2bcad1a67/logo-insights.svg",
    alt: "CoverMyMeds Insights Home"
  }))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__menu"
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "b-bare c-nav__group"
  }, linkList.map(function (link, index) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      className: "b-bare",
      key: index
    }, /*#__PURE__*/React__default['default'].createElement(NavItem, _extends({}, link, {
      isLast: index === linkList.length - 1
    })));
  }))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__toggle"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    className: hamburgerClass,
    "aria-label": "Toggle Navigation Menu",
    onClick: handleHamburgerClick
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "c-hamburger__layer"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "c-hamburger__layer"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "c-hamburger__layer"
  })))));
};
var IndustryNavbar = function IndustryNavbar(_ref7) {
  var _ref7$linkList = _ref7.linkList,
      linkList = _ref7$linkList === void 0 ? [] : _ref7$linkList,
      _ref7$secondaryLinkLi = _ref7.secondaryLinkList,
      secondaryLinkList = _ref7$secondaryLinkLi === void 0 ? [] : _ref7$secondaryLinkLi,
      className = _ref7.className;

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var navClass = classnames("b-caption ".concat(baseClass$4, " ").concat(baseClass$4, "--insights"), _defineProperty({}, "".concat(baseClass$4, "--open"), isOpen), className);
  var hamburgerClass = classnames("b-bare ".concat(hamburgerBaseClass), _defineProperty({}, "".concat(hamburgerBaseClass, "--open"), isOpen));

  var handleHamburgerClick = function handleHamburgerClick() {
    return setIsOpen(!isOpen);
  };

  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      openSubmenu = _useState6[0],
      setOpenSubmenu = _useState6[1];

  var isOpenMenu = openSubmenu !== null; // const container = (target nav); the event listener you're adding and removing is focusin

  var container = React.useRef();

  var handleFocusOut = function handleFocusOut(event) {
    if (isOpenMenu && !container.current.contains(event.target)) setOpenSubmenu(null);
  };

  React.useEffect(function () {
    //adding event listener to body
    document.body.addEventListener('focusin', handleFocusOut);
    return function () {
      document.body.removeEventListener('focusin', handleFocusOut);
    };
  }, [isOpenMenu]);
  return /*#__PURE__*/React__default['default'].createElement("nav", {
    className: navClass,
    ref: container,
    id: "nav-container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__wrap"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://www.covermymeds.health",
    className: "c-nav__logo-link"
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    src: "https://images.ctfassets.net/2in405srp47m/2Cl7WaodG44ouEs0u6IUeC/bc09b35a4b40273d4d64d5e33ae6cccf/covermymeds-logo.svg",
    className: "c-nav__logo",
    alt: "CoverMyMeds Home"
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__menu"
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "b-bare c-nav__group"
  }, linkList.map(function (props, index) {
    return /*#__PURE__*/React__default['default'].createElement(NavItem, _extends({
      openSubmenu: openSubmenu,
      setOpenSubmenu: setOpenSubmenu
    }, props, {
      index: index,
      key: index
    }));
  })), /*#__PURE__*/React__default['default'].createElement("hr", {
    className: "b-bare c-nav__break"
  }), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "b-bare c-nav__group"
  }, secondaryLinkList.map(function (props, index) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      className: "b-bare",
      key: index
    }, /*#__PURE__*/React__default['default'].createElement(NavItem, _extends({}, props, {
      index: index
    })));
  }))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "c-nav__toggle"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    className: hamburgerClass,
    "aria-label": "Toggle Navigation Menu",
    onClick: handleHamburgerClick
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "c-hamburger__layer"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "c-hamburger__layer"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "c-hamburger__layer"
  })))));
};

var navbars = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InsightsNavbar: InsightsNavbar,
  IndustryNavbar: IndustryNavbar
});

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var defaultProps = {
  preventDefaultTouchmoveEvent: false,
  delta: 10,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState = {
  xy: [0, 0],
  swiping: false,
  eventData: undefined,
  start: undefined
};
var LEFT = 'Left';
var RIGHT = 'Right';
var UP = 'Up';
var DOWN = 'Down';
var touchStart = 'touchstart';
var touchMove = 'touchmove';
var touchEnd = 'touchend';
var mouseMove = 'mousemove';
var mouseUp = 'mouseup';

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return LEFT;
    }

    return RIGHT;
  } else if (deltaY > 0) {
    return UP;
  }

  return DOWN;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event.touches && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends$1({}, state, initialState, {
        eventData: {
          initial: [].concat(xy),
          first: true
        },
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
        return state;
      }

      var _ref2 = event.touches ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = state.xy[0] - x;
      var deltaY = state.xy[1] - y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);

      var eventData = _extends$1({}, state.eventData, {
        event: event,
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        velocity: velocity,
        dir: dir
      });

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault(); // first is now always false

      return _extends$1({}, state, {
        eventData: _extends$1({}, eventData, {
          first: false
        }),
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping) {
        eventData = _extends$1({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
      }

      return _extends$1({}, state, initialState, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };

  var attachTouch = function attachTouch(el) {
    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h);
      }); // return properly scoped cleanup method for removing listeners

      return function () {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = null;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends$1({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef // if track mouse attach mouse down listener

  };

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = null;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el);
    }
  }

  return _extends$1({}, state, addState);
}
var Swipeable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Swipeable, _React$PureComponent);

  function Swipeable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _this._set = function (cb) {
      _this.transientState = cb(_this.transientState, _this.props);
    };

    _this.transientState = _extends$1({}, initialState, {
      type: 'class'
    });
    return _this;
  }

  var _proto = Swipeable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        _this$props$nodeName = _this$props.nodeName,
        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
        innerRef = _this$props.innerRef,
        children = _this$props.children,
        trackMouse = _this$props.trackMouse;

    var _getHandlers = getHandlers(this._set, {
      trackMouse: trackMouse
    }),
        handlers = _getHandlers[0],
        attachTouch = _getHandlers[1];

    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
    var ref = innerRef ? function (el) {
      return innerRef(el), handlers.ref(el);
    } : handlers.ref;
    return React__default['default'].createElement(nodeName, _extends$1({}, handlers, {
      className: className,
      style: style,
      ref: ref
    }), children);
  };

  return Swipeable;
}(React__default['default'].PureComponent);
Swipeable.propTypes = {
  onSwiped: propTypes.func,
  onSwiping: propTypes.func,
  onSwipedUp: propTypes.func,
  onSwipedRight: propTypes.func,
  onSwipedDown: propTypes.func,
  onSwipedLeft: propTypes.func,
  delta: propTypes.number,
  preventDefaultTouchmoveEvent: propTypes.bool,
  nodeName: propTypes.string,
  trackMouse: propTypes.bool,
  trackTouch: propTypes.bool,
  innerRef: propTypes.func,
  rotationAngle: propTypes.number
};
Swipeable.defaultProps = defaultProps;

var _excluded$8 = ["src", "alt", "children"],
    _excluded2$5 = ["src", "children", "trackUrl"];
var defaultMediaSliderContext = {
  activeSlideIndex: 0,
  slideList: [],
  isFullScreen: false
};

var mediaSliderReducer = function mediaSliderReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMediaSliderContext;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  var updateState = function updateState() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.assign({}, state, obj);
  };

  var actionTypeResolver = {};

  actionTypeResolver['add'] = function () {
    return updateState({
      slideList: [].concat(_toConsumableArray(state.slideList), [payload])
    });
  };

  actionTypeResolver['remove'] = function () {
    return updateState({
      slideList: state.slideList.filter(function (sl) {
        return sl.slideId !== payload.slideId;
      })
    });
  };

  actionTypeResolver['next'] = function () {
    return updateState({
      activeSlideIndex: state.activeSlideIndex < state.slideList.length - 1 ? state.activeSlideIndex + 1 : 0
    });
  };

  actionTypeResolver['prev'] = function () {
    return updateState({
      activeSlideIndex: state.activeSlideIndex > 0 ? state.activeSlideIndex - 1 : state.slideList.length - 1
    });
  };

  actionTypeResolver['toggleFullScreen'] = function () {
    return updateState({
      isFullScreen: !state.isFullScreen
    });
  };

  return actionTypeResolver[type] ? actionTypeResolver[type]() : state;
};

var MediaSliderContext = /*#__PURE__*/React__default['default'].createContext(_objectSpread2(_objectSpread2({
  sliderId: {
    current: 0
  }
}, defaultMediaSliderContext), {}, {
  dispatchMediaSlider: function dispatchMediaSlider() {}
}));
var baseClass$5 = 'c-media-slider';
var MediaSlider = function MediaSlider(_ref2) {
  var children = _ref2.children,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title;

  var _useReducer = React.useReducer(mediaSliderReducer, defaultMediaSliderContext),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      mediaSliderState = _useReducer2[0],
      dispatchMediaSlider = _useReducer2[1];

  var sliderId = React.useRef(nanoid());

  var contextValue = _objectSpread2(_objectSpread2({}, mediaSliderState), {}, {
    sliderId: sliderId,
    dispatchMediaSlider: dispatchMediaSlider
  });

  var mediaSliderClass = classnames(baseClass$5, _defineProperty({}, "".concat(baseClass$5, "--fullscreen"), mediaSliderState.isFullScreen));
  return /*#__PURE__*/React__default['default'].createElement(MediaSliderContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    id: sliderId.current,
    className: mediaSliderClass,
    "aria-live": "polite",
    role: "region",
    "aria-roledescription": "carousel",
    "aria-label": title
  }, children, /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare ".concat(baseClass$5, "__arrow ").concat(baseClass$5, "__arrow--prev u-disp-none u-disp-grid@40"),
    onClick: function onClick() {
      return dispatchMediaSlider({
        type: "prev"
      });
    },
    "aria-controls": "".concat(sliderId.current)
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "u-width-100",
    src: "https://images.ctfassets.net/70w6ftfzv4je/2rxxuOF4Ciph7kxg7f6CZu/1ed247d05f4e567f3dc68c60469ad185/slider_back.svg",
    alt: "Go to Previous Slide"
  })), /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare ".concat(baseClass$5, "__arrow ").concat(baseClass$5, "__arrow--next u-disp-none u-disp-grid@40"),
    onClick: function onClick() {
      return dispatchMediaSlider({
        type: "next"
      });
    },
    "aria-controls": "".concat(sliderId.current)
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "u-width-100",
    src: "https://images.ctfassets.net/70w6ftfzv4je/2ggaLcW59MUwsVoIGJGRJI/4dcd3220177c564ed72802c395b4f969/slider_forward.svg",
    alt: "Go to Next Slide"
  })), /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare ".concat(baseClass$5, "__expand"),
    onClick: function onClick() {
      return dispatchMediaSlider({
        type: "toggleFullScreen"
      });
    },
    "aria-controls": "".concat(sliderId.current)
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    src: "https://images.ctfassets.net/70w6ftfzv4je/5HBOxxvnS9jDqz80avmoL8/f881a9677f09c4603f66e4cb71e701ba/slider_expand.svg",
    alt: "Expand carousel"
  })), /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare ".concat(baseClass$5, "__close"),
    onClick: function onClick() {
      return dispatchMediaSlider({
        type: "toggleFullScreen"
      });
    },
    "aria-controls": "".concat(sliderId.current)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "u-disp-flex"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$5, "__close-text b-txt-btn u-mar-right-10")
  }, "Close"), /*#__PURE__*/React__default['default'].createElement("img", {
    src: "https://images.ctfassets.net/2in405srp47m/s1Unu28gdBCDxI1DaOknU/c161544819a17be144077a9d34cd4c5a/exit.svg",
    className: "".concat(baseClass$5, "__exit"),
    alt: ""
  })))));
};
var linkRenderer = function linkRenderer(_ref3) {
  var _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title,
      _ref3$href = _ref3.href,
      href = _ref3$href === void 0 ? '' : _ref3$href,
      children = _ref3.children;
  var linkText = renderToStaticMarkup(children);
  var linkType = linkText.toLowerCase() === 'ref' ? 'footnote' : 'default';
  var resolveLink = {};

  resolveLink['default'] = function () {
    return /*#__PURE__*/React__default['default'].createElement("a", {
      className: "u-color-magenta",
      href: href,
      title: title,
      target: "blank"
    }, children);
  };

  resolveLink['footnote'] = function () {
    var hasLink = href !== '#';
    var refHref = hasLink ? href.trim() : null;
    return /*#__PURE__*/React__default['default'].createElement(Footnotes.Reference, {
      title: title,
      href: refHref
    });
  };

  return resolveLink[linkType]();
};

var MediaSlide = function MediaSlide(_ref5) {
  var caption = _ref5.caption,
      children = _ref5.children,
      slideId = _ref5.slideId;
  var slideElmClass = "".concat(baseClass$5, "__slide");

  var _useContext = React.useContext(MediaSliderContext),
      activeSlideIndex = _useContext.activeSlideIndex,
      slideList = _useContext.slideList,
      dispatchMediaSlider = _useContext.dispatchMediaSlider,
      sliderId = _useContext.sliderId;

  var slideIndex = slideList.findIndex(function (s) {
    return s.slideId === slideId;
  });
  var isCurrent = slideIndex === activeSlideIndex;
  var slideClass = classnames('b-bare', slideElmClass, _defineProperty({}, "".concat(slideElmClass, "--active"), isCurrent));
  var variableLabel = "".concat(slideIndex + 1, " of ").concat(slideList.length);
  React.useEffect(function () {
    dispatchMediaSlider({
      type: 'add',
      payload: {
        slideId: slideId
      }
    });
    return function () {
      return dispatchMediaSlider({
        type: 'remove',
        payload: {
          slideId: slideId
        }
      });
    };
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("figure", {
    className: slideClass,
    role: "group",
    "aria-roledescription": "slide",
    "aria-label": variableLabel,
    "aria-hidden": !isCurrent
  }, /*#__PURE__*/React__default['default'].createElement(Swipeable, {
    className: "".concat(baseClass$5, "__media-container"),
    onSwipedLeft: function onSwipedLeft() {
      return dispatchMediaSlider({
        type: "next"
      });
    },
    onSwipedRight: function onSwipedRight() {
      return dispatchMediaSlider({
        type: "prev"
      });
    },
    trackMouse: true,
    trackTouch: true
  }, children), /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare b-body b-body--small ".concat(baseClass$5, "__mobile-expand"),
    onClick: function onClick() {
      return dispatchMediaSlider({
        type: "toggleFullScreen"
      });
    },
    "aria-controls": sliderId.current
  }, "Tap to Expand"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$5, "__caption-container")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$5, "__caption")
  }, /*#__PURE__*/React__default['default'].createElement("figcaption", null, caption), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$5, "__page ").concat(baseClass$5, "--fullscreen__page b-body b-body--small u-color-dark-grey")
  }, "(", activeSlideIndex + 1, "/", slideList.length, ")"))));
};

MediaSlider.Image = function (_ref6) {
  var src = _ref6.src,
      alt = _ref6.alt,
      children = _ref6.children,
      rProps = _objectWithoutProperties(_ref6, _excluded$8);

  return /*#__PURE__*/React__default['default'].createElement(MediaSlide, _extends({
    caption: children
  }, rProps), /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass$5, "__media"),
    src: src,
    alt: alt,
    draggable: false
  }));
};

var Track = function Track(trackUrl) {
  if (!trackUrl) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("track", {
    "default": true,
    src: trackUrl,
    kind: "captions",
    srcLang: "en"
  });
};

MediaSlider.Video = function (_ref7) {
  var src = _ref7.src,
      children = _ref7.children,
      trackUrl = _ref7.trackUrl,
      rProps = _objectWithoutProperties(_ref7, _excluded2$5);

  return /*#__PURE__*/React__default['default'].createElement(MediaSlide, _extends({
    caption: children
  }, rProps), /*#__PURE__*/React__default['default'].createElement("video", {
    className: "".concat(baseClass$5, "__media")
  }, /*#__PURE__*/React__default['default'].createElement("source", {
    src: src,
    type: "video/mp4"
  }), /*#__PURE__*/React__default['default'].createElement(Track, {
    trackUrl: trackUrl
  })));
};

var mediaslider = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MediaSlider: MediaSlider,
  linkRenderer: linkRenderer
});

var _excluded$9 = ["footnoteId"];
var FootnoteContext = /*#__PURE__*/React__default['default'].createContext({
  footnoteList: []
});

var FootnoteCitation = function FootnoteCitation(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      href = _ref.href;
  var Elm = href ? function (p) {
    return /*#__PURE__*/React__default['default'].createElement("a", _extends({
      className: "b-link",
      target: "_blank"
    }, p));
  } : 'span';
  return /*#__PURE__*/React__default['default'].createElement(Elm, {
    href: href
  }, title);
};

var FootnoteList = function FootnoteList() {
  var _useContext = React.useContext(FootnoteContext),
      footnoteList = _useContext.footnoteList;

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "b-caption u-mar-bottom-80"
  }, /*#__PURE__*/React__default['default'].createElement("ol", null, footnoteList.map(function (props, i) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      className: "u-mar-vt-10 u-txt-left",
      key: i
    }, /*#__PURE__*/React__default['default'].createElement(FootnoteCitation, props));
  })));
};

var FootnoteRef = function FootnoteRef(_ref2) {
  var footnoteId = _ref2.footnoteId,
      rProps = _objectWithoutProperties(_ref2, _excluded$9);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var footnoteElm = React.useRef();
  var citationElm = React.useRef();

  var _useContext2 = React.useContext(FootnoteContext),
      _useContext2$footnote = _useContext2.footnoteList,
      footnoteList = _useContext2$footnote === void 0 ? [] : _useContext2$footnote;

  var toggleIsOpen = function toggleIsOpen() {
    return setIsOpen(!isOpen);
  };

  var footnoteNumber = footnoteList.findIndex(function (fn) {
    return fn.href === rProps.href && fn.title === rProps.title;
  }) + 1;
  var className = "c-inline-reference ".concat(isOpen ? 'c-inline-reference--open' : '');

  var handleOutsideInteraction = function handleOutsideInteraction(event) {
    if (!footnoteElm.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(function () {
    document.documentElement.addEventListener('click', handleOutsideInteraction);
    document.documentElement.addEventListener('focusin', handleOutsideInteraction);
    document.documentElement.addEventListener('keydown', handleOutsideInteraction);
    return function () {
      document.documentElement.removeEventListener('click', handleOutsideInteraction);
      document.documentElement.removeEventListener('focusin', handleOutsideInteraction);
      document.documentElement.removeEventListener('keydown', handleOutsideInteraction);
    };
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("span", {
    ref: footnoteElm,
    className: className
  }, /*#__PURE__*/React__default['default'].createElement("sup", null, /*#__PURE__*/React__default['default'].createElement("button", {
    className: "b-bare o-underline-hover u-color-magenta u-fw-bold",
    "aria-label": "Footnote ".concat(footnoteNumber),
    "aria-expanded": isOpen,
    onClick: toggleIsOpen
  }, "[", footnoteNumber, "]")), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-caption u-color-black u-fw-normal c-inline-reference__content",
    ref: citationElm,
    "data-footnote-number": footnoteNumber,
    start: footnoteNumber
  }, /*#__PURE__*/React__default['default'].createElement(FootnoteCitation, rProps)));
};

var Footnotes$1 = function Footnotes(_ref3) {
  var children = _ref3.children,
      footnoteList = _ref3.footnoteList;
  return /*#__PURE__*/React__default['default'].createElement(FootnoteContext.Provider, {
    value: {
      footnoteList: footnoteList
    }
  }, children);
};
Footnotes$1.List = FootnoteList;
Footnotes$1.Reference = FootnoteRef;

var footnotes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Footnotes: Footnotes$1
});

var _excluded$a = ["label", "children", "id"];
var baseClass$6 = 'c-listbox';
var listboxDefaultState = {
  selectedOptionId: null,
  activeOptionId: null,
  isOpen: false,
  searchTerm: '',
  optionList: [],
  listboxId: {
    current: null
  },
  buttonElm: {
    current: null
  }
};

var listboxReducer = function listboxReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : listboxDefaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var actionTypeResolver = {};
  var optionList = state === null || state === void 0 ? void 0 : state.optionList;

  var updateState = function updateState() {
    var targetProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.assign({}, state, targetProps);
  };

  actionTypeResolver['add_option'] = function () {
    var payload = action.payload;
    var doesOptionExist = !!optionList.find(function (opt) {
      return opt.optionId === (payload === null || payload === void 0 ? void 0 : payload.optionId);
    });
    var updatedOptionList = doesOptionExist ? optionList.map(function (opt) {
      return opt.optionId === payload.optionId ? payload : opt;
    }) : [].concat(_toConsumableArray(optionList), [payload]);
    return updateState({
      optionList: updatedOptionList
    });
  };

  actionTypeResolver['remove_option'] = function () {
    return updateState({
      optionList: optionList.filter(function (opt) {
        var _action$payload;

        return (opt === null || opt === void 0 ? void 0 : opt.optionId) !== (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.optionId);
      })
    });
  };

  actionTypeResolver['set_active'] = function () {
    var _action$payload2;

    return updateState({
      activeOptionId: action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.optionId
    });
  };

  actionTypeResolver['set_selected'] = function () {
    var _action$payload3;

    return updateState({
      selectedOptionId: action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.optionId
    });
  };

  actionTypeResolver['open'] = function () {
    var _optionList$;

    return updateState({
      isOpen: true,
      activeOptionId: (state === null || state === void 0 ? void 0 : state.selectedOptionId) || ((_optionList$ = optionList[0]) === null || _optionList$ === void 0 ? void 0 : _optionList$.optionId) || null
    });
  };

  actionTypeResolver['close'] = function () {
    return updateState({
      isOpen: false,
      activeOptionId: null
    });
  };

  actionTypeResolver['add_search_char'] = function () {
    var _action$payload4;

    return updateState({
      searchTerm: "".concat(state === null || state === void 0 ? void 0 : state.searchTerm).concat(action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.key)
    });
  };

  actionTypeResolver['clear_search'] = function () {
    return updateState({
      searchTerm: ''
    });
  };

  actionTypeResolver['set_button'] = function () {
    var _action$payload5;

    return updateState({
      buttonElm: action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.buttonElm
    });
  };

  return actionTypeResolver[action === null || action === void 0 ? void 0 : action.type] ? actionTypeResolver[action === null || action === void 0 ? void 0 : action.type]() : state;
};

var ListboxContext = /*#__PURE__*/React__default['default'].createContext(_objectSpread2(_objectSpread2({}, listboxDefaultState), {}, {
  dispatchListbox: function dispatchListbox() {}
}));

var ListboxLabel = function ListboxLabel(_ref) {
  var children = _ref.children;

  var _useContext = React.useContext(ListboxContext),
      isOpen = _useContext.isOpen,
      dispatchListbox = _useContext.dispatchListbox,
      selectedOptionId = _useContext.selectedOptionId,
      listboxId = _useContext.listboxId;

  var handleClick = function handleClick() {
    return dispatchListbox({
      type: 'open'
    });
  };

  var labelClass = classnames(" ".concat(baseClass$6, "__label"), _defineProperty({}, "".concat(baseClass$6, "__label--float"), isOpen || !!selectedOptionId));
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "".concat(listboxId.current, "_label"),
    className: labelClass,
    onClick: handleClick
  }, children);
};

var ListboxButton = function ListboxButton() {
  var _optionList$find;

  var _useContext2 = React.useContext(ListboxContext),
      optionList = _useContext2.optionList,
      isOpen = _useContext2.isOpen,
      listboxId = _useContext2.listboxId,
      selectedOptionId = _useContext2.selectedOptionId,
      dispatchListbox = _useContext2.dispatchListbox;

  var fieldValue = (optionList === null || optionList === void 0 ? void 0 : (_optionList$find = optionList.find(function (opt) {
    return opt.optionId === selectedOptionId;
  })) === null || _optionList$find === void 0 ? void 0 : _optionList$find.value) || '';
  var buttonElm = React.useRef();

  var handleKeyUp = function handleKeyUp(event) {
    var keyResolver = {};
    var key = event.key;

    keyResolver['Enter'] = function () {
      return dispatchListbox({
        type: 'open'
      });
    };

    keyResolver[' '] = function () {
      return dispatchListbox({
        type: 'open'
      });
    };

    keyResolver['ArrowDown'] = function () {
      return dispatchListbox({
        type: 'open'
      });
    };

    if (keyResolver[key]) {
      event.stopPropagation();
      event.preventDefault();
      keyResolver[key]();
    }
  };

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    dispatchListbox({
      type: 'open'
    });
  };

  var btnProps = {
    className: "b-bare ".concat(baseClass$6, "__btn"),
    id: "".concat(listboxId.current, "_btn"),
    'aria-labelledby': "".concat(listboxId.current, "_label ").concat(listboxId.current, "_btn"),
    'aria-expanded': isOpen ? true : undefined,
    'aria-haspopup': 'listbox',
    onClick: handleClick,
    onKeyDown: handleKeyUp
  };
  React.useEffect(function () {
    dispatchListbox({
      type: 'set_button',
      payload: {
        buttonElm: buttonElm
      }
    });
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("button", _extends({
    ref: buttonElm,
    type: "button"
  }, btnProps), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(baseClass$6, "__value")
  }, fieldValue, "\xA0"), /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "".concat(baseClass$6, "__arrow"),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#707070",
    d: "M480.61005,400.23931a31.89631,31.89631,0,0,1-22.625-9.375l-201.375-201.375-201.375,201.375a31.99658,31.99658,0,0,1-45.25-45.25l224-224a31.98833,31.98833,0,0,1,45.25,0l224,224a32,32,0,0,1-22.625,54.625Z"
  })));
};

var ListboxMenu = function ListboxMenu(_ref2) {
  var children = _ref2.children;

  var _useContext3 = React.useContext(ListboxContext),
      isOpen = _useContext3.isOpen,
      optionList = _useContext3.optionList,
      listboxId = _useContext3.listboxId,
      buttonElm = _useContext3.buttonElm,
      searchTerm = _useContext3.searchTerm,
      activeOptionId = _useContext3.activeOptionId,
      dispatchListbox = _useContext3.dispatchListbox;

  var elm = React.useRef();
  var searchTimeout = React.useRef(0);

  var getActiveOptionIndex = function getActiveOptionIndex() {
    return optionList.findIndex(function (opt) {
      return opt.optionId === activeOptionId;
    });
  };

  var getFirstOptionId = function getFirstOptionId() {
    var _optionList$2;

    return (_optionList$2 = optionList[0]) === null || _optionList$2 === void 0 ? void 0 : _optionList$2.optionId;
  };

  var getLastOptionId = function getLastOptionId() {
    var _optionList;

    return (_optionList = optionList[optionList.length - 1]) === null || _optionList === void 0 ? void 0 : _optionList.optionId;
  };

  var getNextActiveOptionId = function getNextActiveOptionId() {
    var _optionList2;

    var activeOptionIndex = getActiveOptionIndex();
    return activeOptionIndex >= optionList.length - 1 ? getLastOptionId() : (_optionList2 = optionList[activeOptionIndex + 1]) === null || _optionList2 === void 0 ? void 0 : _optionList2.optionId;
  };

  var getPreviousActiveOptionId = function getPreviousActiveOptionId() {
    var _optionList3;

    var activeOptionIndex = getActiveOptionIndex();
    return activeOptionIndex <= 0 ? getFirstOptionId() : (_optionList3 = optionList[activeOptionIndex - 1]) === null || _optionList3 === void 0 ? void 0 : _optionList3.optionId;
  };

  var handleKeyDown = function handleKeyDown(event) {
    var key = event.key;
    var keyResolver = {};

    keyResolver['Enter'] = function () {
      dispatchListbox({
        type: 'set_selected',
        payload: {
          optionId: activeOptionId
        }
      });
      dispatchListbox({
        type: 'close'
      });
      buttonElm.current.focus();
    };

    keyResolver[' '] = keyResolver['Enter'];

    keyResolver['ArrowDown'] = function () {
      dispatchListbox({
        type: 'set_active',
        payload: {
          optionId: getNextActiveOptionId()
        }
      });
    };

    keyResolver['ArrowUp'] = function () {
      dispatchListbox({
        type: 'set_active',
        payload: {
          optionId: getPreviousActiveOptionId()
        }
      });
    };

    keyResolver['Home'] = function () {
      dispatchListbox({
        type: 'set_active',
        payload: {
          optionId: getFirstOptionId()
        }
      });
    };

    keyResolver['End'] = function () {
      dispatchListbox({
        type: 'set_active',
        payload: {
          optionId: getLastOptionId()
        }
      });
    };

    keyResolver["Escape"] = function () {
      dispatchListbox({
        type: "close"
      });
      buttonElm.current.focus();
    };

    keyResolver['default'] = function () {
      if (key.length === 1) {
        clearTimeout(searchTimeout.current);
        dispatchListbox({
          type: 'add_search_char',
          payload: {
            key: key
          }
        });
        searchTimeout.current = setTimeout(function () {
          dispatchListbox({
            type: 'clear_search'
          });
        }, 500);
      }
    };

    if (keyResolver[key]) {
      event.preventDefault();
      event.stopPropagation();
      keyResolver[key]();
    } else {
      keyResolver['default']();
    }
  };

  var handleBlur = function handleBlur() {
    dispatchListbox({
      type: "close"
    });
  };

  var menuProps = {
    className: "b-bare ".concat(baseClass$6, "__menu"),
    role: 'listbox',
    'aria-labelledby': "".concat(listboxId.current, "_label"),
    'aria-activedescendant': activeOptionId || undefined,
    tabIndex: -1,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur
  };
  React.useEffect(function () {
    if (!isOpen || searchTerm.length < 1) {
      return;
    }

    var activeIndex = getActiveOptionIndex();
    var mergedList = optionList.map(function (opt, index) {
      return _objectSpread2(_objectSpread2({}, opt), {}, {
        index: index
      });
    });
    var resultList = mergedList.filter(function (opt) {
      return (opt === null || opt === void 0 ? void 0 : opt.value.toUpperCase().indexOf(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toUpperCase())) === 0;
    });
    var firstResult = resultList[0];
    var nextResult = resultList.find(function (_ref3) {
      var index = _ref3.index;
      return index > activeIndex;
    }) || firstResult;

    if (nextResult !== null && nextResult !== void 0 && nextResult.optionId) {
      dispatchListbox({
        type: 'set_active',
        payload: {
          optionId: nextResult === null || nextResult === void 0 ? void 0 : nextResult.optionId
        }
      });
    }
  }, [searchTerm]);
  React.useEffect(function () {
    if (isOpen) {
      elm.current.focus();
    }
  }, [isOpen]);
  return /*#__PURE__*/React__default['default'].createElement("ul", _extends({
    ref: elm
  }, menuProps), children);
};

var ListboxOption = function ListboxOption(_ref4) {
  var value = _ref4.value,
      id = _ref4.id;
  var elmClass = "".concat(baseClass$6, "__opt");
  var optionId = React.useRef(id || nanoid());
  var optElm = React.useRef();

  var _useContext4 = React.useContext(ListboxContext),
      dispatchListbox = _useContext4.dispatchListbox,
      isOpen = _useContext4.isOpen,
      buttonElm = _useContext4.buttonElm,
      selectedOptionId = _useContext4.selectedOptionId,
      activeOptionId = _useContext4.activeOptionId;

  var isSelected = selectedOptionId === optionId.current;
  var isActive = activeOptionId === optionId.current;

  var handleClick = function handleClick() {
    dispatchListbox({
      type: "set_selected",
      payload: {
        optionId: optionId.current
      }
    });
    dispatchListbox({
      type: 'close'
    });
    buttonElm.current.focus();
  };

  var optionProps = {
    className: classnames('b-bare', elmClass, _defineProperty({}, "".concat(elmClass, "--active"), isActive)),
    role: 'option',
    'aria-selected': isSelected ? true : undefined,
    onClick: handleClick
  };
  React.useEffect(function () {
    if (isActive && isOpen) {
      optElm.current.scrollIntoView({
        block: "nearest",
        behavior: 'smooth'
      });
    }
  }, [isActive, isOpen]);
  React.useEffect(function () {
    dispatchListbox({
      type: "add_option",
      payload: {
        optionId: optionId.current,
        value: value
      }
    });
    return function () {
      dispatchListbox({
        type: "remove_option",
        payload: {
          optionId: optionId.current
        }
      });
    };
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("li", _extends({
    ref: optElm
  }, optionProps), value);
};

var Listbox = function Listbox(_ref5) {
  var _state$optionList$fin;

  var label = _ref5.label,
      children = _ref5.children,
      id = _ref5.id,
      rProps = _objectWithoutProperties(_ref5, _excluded$a);

  var listboxId = React.useRef(id || nanoid());

  var _useReducer = React.useReducer(listboxReducer, listboxDefaultState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatchListbox = _useReducer2[1];

  var listboxClass = classnames("b-body", baseClass$6, _defineProperty({}, "".concat(baseClass$6, "--open"), state === null || state === void 0 ? void 0 : state.isOpen));

  var inputProps = _objectSpread2(_objectSpread2({
    id: "".concat(listboxId.current, "_field")
  }, rProps), {}, {
    type: 'hidden',
    className: "b-bare ".concat(baseClass$6, "__field"),
    value: (state === null || state === void 0 ? void 0 : (_state$optionList$fin = state.optionList.find(function (opt) {
      return opt.optionId === (state === null || state === void 0 ? void 0 : state.selectedOptionId);
    })) === null || _state$optionList$fin === void 0 ? void 0 : _state$optionList$fin.value) || ''
  });

  var contextValue = Object.assign({}, state, {
    listboxId: listboxId,
    dispatchListbox: dispatchListbox
  }); // Using a ReadOnly Input field to try and tap into native required functionality.

  return /*#__PURE__*/React__default['default'].createElement(ListboxContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: listboxClass
  }, /*#__PURE__*/React__default['default'].createElement(ListboxLabel, null, label), /*#__PURE__*/React__default['default'].createElement(ListboxButton, null), /*#__PURE__*/React__default['default'].createElement("input", inputProps), /*#__PURE__*/React__default['default'].createElement(ListboxMenu, null, children)));
};
Listbox.Option = ListboxOption;

var listbox = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Listbox: Listbox
});

var _excluded$b = ["className"],
    _excluded2$6 = ["className"],
    _excluded3$3 = ["className"];
var baseClass$7 = 'c-insights-subscribe';
var subscribeFormUrl = 'https://images.ctfassets.net/70w6ftfzv4je/ACelG83zRvus3FJWZr2CR/2c48a3e4fb653a9cfe05aafc0a2f1d3f/subscribe-phone.png';
var Subscribe = function Subscribe(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: baseClass$7
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$7, "__content")
  }, children), /*#__PURE__*/React__default['default'].createElement("img", {
    className: "".concat(baseClass$7, "__phone"),
    src: subscribeFormUrl,
    alt: "iPhone showcasing News and Insights Article"
  }));
};

Subscribe.Heading = function (_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      p = _objectWithoutProperties(_ref2, _excluded$b);

  return /*#__PURE__*/React__default['default'].createElement(Headline4, _extends({
    className: "u-mar-right-40@40 u-mar-bottom-20 ".concat(className).trim()
  }, p));
};

Subscribe.Form = function (_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      p = _objectWithoutProperties(_ref3, _excluded2$6);

  return /*#__PURE__*/React__default['default'].createElement("form", _extends({
    className: "".concat(baseClass$7, "__form ").concat(className).trim()
  }, p));
};

Subscribe.Field = function (p) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$7, "__email")
  }, /*#__PURE__*/React__default['default'].createElement(Textbox, _extends({
    hasBackground: true
  }, p)));
};

Subscribe.Submit = function (_ref4) {
  var className = _ref4.className,
      p = _objectWithoutProperties(_ref4, _excluded3$3);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(baseClass$7, "__submit")
  }, /*#__PURE__*/React__default['default'].createElement(Button, _extends({
    className: "u-width-100 ".concat(className).trim()
  }, p)));
};

var subscribe = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Subscribe: Subscribe
});

var Source = function Source(_ref) {
  var href = _ref.href,
      title = _ref.title,
      index = _ref.index;
  var Elm = href ? function (p) {
    return /*#__PURE__*/React__default['default'].createElement("a", _extends({
      href: href,
      className: "u-color-magenta",
      target: "_blank"
    }, p));
  } : 'span';
  return /*#__PURE__*/React__default['default'].createElement("li", {
    className: 'b-bare u-mar-vt-10'
  }, /*#__PURE__*/React__default['default'].createElement("span", null, index + 1, "."), " ", /*#__PURE__*/React__default['default'].createElement(Elm, null, title));
};

var baseClass$8 = 'o-expandable-source-list';
var ExpandableSourceList = function ExpandableSourceList(_ref2) {
  var _ref2$sourceList = _ref2.sourceList,
      sourceList = _ref2$sourceList === void 0 ? [] : _ref2$sourceList;
  if (sourceList.length < 1) return null;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var label = "".concat(isOpen ? 'Collapse' : 'Expand', " Sources");
  var listClasses = classnames('b-caption', baseClass$8, _defineProperty({}, "".concat(baseClass$8, "--open"), isOpen));

  var handleClick = function handleClick() {
    return setIsOpen(!isOpen);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: listClasses
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: handleClick,
    className: "b-bare u-pad-vt-20 o-expandable-source-list__btn u-disp-flex u-width-100"
  }, /*#__PURE__*/React__default['default'].createElement("div", null, label), /*#__PURE__*/React__default['default'].createElement("img", {
    className: "o-expandable-source-list__arrow",
    src: "https://images.ctfassets.net/70w6ftfzv4je/3ZNfQtyqPZ95m0ZFRrOvB5/82c57d121fa016c7c5d461cc42f51bb5/accordion-arrow.svg",
    alt: ""
  })), /*#__PURE__*/React__default['default'].createElement("ol", {
    className: "b-bare ".concat(baseClass$8, "__list")
  }, sourceList.map(function (s, i) {
    return /*#__PURE__*/React__default['default'].createElement(Source, _extends({
      key: i,
      index: i
    }, s));
  })));
};

var sourcelist = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ExpandableSourceList: ExpandableSourceList
});

var cmmCookieHelpers = function cmmCookieHelpers(operation, cookie_name, expiry_utc_string) {
  /**
   * Appends the current landing page name to the landing page cookie
   * @param {string} landing_page_name
   */
  var updateLandingPageCookie = function updateLandingPageCookie(landing_page_name) {
    landing_page_name = isValidParam(landing_page_name);
    if (!landing_page_name) return;
    var cookie_data = cookieRead('landing_page_cookie');
    cookie_data.push({
      landing_page_name: landing_page_name,
      page_url: window.location.href,
      timestamp: Math.round(new Date().getTime() / 1000)
    });

    while (cookie_data.length > 0 && !isCookieLengthValid(cookie_data)) {
      cookie_data.shift();
    }

    if (cookie_data.length > 0) {
      cookieWrite('landing_page_cookie', '', cookie_data); // writes the current page info to cookie (along with everything which existed before)
    }
  };
  /**
   * Retrieves a cookie
   * @param {string} cookie_name
   * @return {boolean|Object[]} returns false if empty cookie_name else an array
   */


  var cookieRead = function cookieRead(cookie_name) {
    cookie_name = isValidParam(cookie_name);
    if (!cookie_name) return false;
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var key;
    var val;

    for (var i in cookies) {
      var cookie = cookies[i].split('=');

      if (cookie.length === 2) {
        key = cookie[0];

        if (key === cookie_name) {
          val = cookie[1];
          break;
        }
      }
    }

    if (val && val.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      val = val.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      var cookie_data = JSON.parse(decodeURIComponent(val));

      if (cookie_data == null || cookie_data.constructor !== Array) {
        cookie_data = [];
      }
    } catch (e) {
      var cookie_data = [];
    }

    return cookie_data;
  };
  /**
   * Writes a cookie
   * @param {string} cookie_name
   * @param {string} expiry_utc_string - pass empty string for a default of one year
   * @param {Object[]} cookie_data
   */


  var cookieWrite = function cookieWrite(cookie_name, expiry_utc_string, cookie_data) {
    cookie_name = isValidParam(cookie_name);
    if (!cookie_name) return;
    if (cookie_data == null || cookie_data.constructor !== Array) return;

    if (!expiry_utc_string || !Date.parse(expiry_utc_string)) {
      var expDate = new Date();
      expDate.setDate(expDate.getDate() + 90); //Each time a new item is added to the cookie, the expiration is set to 90 days from that day

      expiry_utc_string = expDate.toUTCString();
    }

    cookie_data = encodeURIComponent(JSON.stringify(cookie_data));
    document.cookie = [encodeURIComponent(cookie_name), '=', cookie_data, ';expires=' + expiry_utc_string, ';path=' + '/', ';domain=.covermymeds.com', ';secure'].join('');
  };
  /**
   * Returns an object created from the query parameters and values in the current URL
   * @return {Object} query_object
   */


  var getQueryObject = function getQueryObject() {
    var query_object = {};
    var key_val_pairs = window.location.search.substr(1).split('&');

    for (var index in key_val_pairs) {
      var key_val_pair = key_val_pairs[index].split('=');

      if (key_val_pair.length === 2) {
        var key = key_val_pair[0];
        var value = key_val_pair[1];
        query_object[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    }

    return query_object;
  };
  /**
   * Returns the value for a given query parameter in the current URL
   * @param {string} param
   * @return {string|boolean} returns false if param is invalid or does not exist, else returns its associated value
   */


  var getQueryParamValue = function getQueryParamValue(param) {
    param = isValidParam(param);
    if (!param) return false;
    var query_object = getQueryObject();

    if (query_object.hasOwnProperty(param)) {
      return query_object[param];
    }

    return false;
  };
  /**
   * Check if string is null, undefined or empty
   * @param {string} str
   * @return {boolean|string} returns false if the string is null, undefined or empty, else returns a trimmed string
   */


  var isValidParam = function isValidParam(str) {
    if (!str || !str.trim()) return false; // if str is null or empty

    return str.trim();
  };
  /**
   * A cookie can have a maximum size of 4096 bytes, so we only take the latest cookie items whose total size is less than 4000 bytes
   * Assumption: Since the language would be English, each characters would be of 1 byte
   * @param {Object[]} cookie_data
   * @returns {boolean}
   */


  var isCookieLengthValid = function isCookieLengthValid(cookie_data) {
    if (cookie_data == null || cookie_data.constructor !== Array || cookie_data.length === 0) return false;
    var cookie_string = encodeURIComponent(JSON.stringify(cookie_data));
    return cookie_string && cookie_string.length < 4000;
  };
  /**
    * Reads two things:
    * (1) the url param 'utc_campaign', if exists, and
    * (2) a previous instance of a 'ab_version' in the most recently visited page (as found in the cookies set by the above helpers), if exists
    * (so that on page refresh, a user receives the same a/b version of the page, if that page is currently undergoing an a/b test)
    * and constructs a url param-like string to set as the 'landing_page_name' of this page visit
    * which can later be parsed for tracking purposes
  */


  var setUpdateCampaignAB = function setUpdateCampaignAB() {
    var ab_version = "";
    var COOKIE_DATA = cookieRead('landing_page_cookie');
    var COOKIE_LENGTH = COOKIE_DATA.length;

    if (COOKIE_LENGTH && COOKIE_DATA[COOKIE_LENGTH - 1].hasOwnProperty('landing_page_name')) {
      var COOKIE_TRACKING = COOKIE_DATA[COOKIE_LENGTH - 1]['landing_page_name'];
      ab_version = COOKIE_TRACKING.indexOf("ab_version=A") !== -1 ? "A" : "B";
    } else {
      ab_version = Math.floor(Math.random() * Math.floor(2)) === 0 ? "A" : "B";
    }

    var CAMP_STR = getQueryParamValue('utm_campaign') || 'none-specified';
    var COOKIE_STRING = "campaign=".concat(CAMP_STR, "&ab_version=").concat(ab_version);
    updateLandingPageCookie(COOKIE_STRING);
    return ab_version;
  };

  var writeNavCookie = function writeNavCookie() {
    var cookie_data = [];
    cookie_data.push({
      landing_page_name: 'scorecard',
      page_url: window.location.href,
      timestamp: Math.round(new Date().getTime() / 1000)
    });
    cookieWrite('seen_nav', '', cookie_data);
  };

  var writeSubscribeCookie = function writeSubscribeCookie() {
    var cookie_data = [];
    cookie_data.push({
      landing_page_name: 'subscribe',
      page_url: window.location.href,
      timestamp: Math.round(new Date().getTime() / 1000)
    });
    cookieWrite('subscribed', '', cookie_data);
  };

  var writeWhitePaperCookie = function writeWhitePaperCookie() {
    var white_paper_data = [];
    white_paper_data.push({
      landing_page_name: 'whitePaper',
      page_url: window.location.href,
      timestamp: Math.round(new Date().getTime() / 1000)
    });
    cookieWrite('whitePaper', '', cookie_data);
  };

  switch (operation) {
    case "update-cookie":
      return function (landing_page_name) {
        return updateLandingPageCookie(landing_page_name);
      };

    case "get-query":
      return function (param) {
        return getQueryParamValue(param);
      };

    case "read-cookie":
      return function (cookie_name) {
        return cookieRead(cookie_name);
      };

    case "set-update-campaign-ab":
      return function () {
        return setUpdateCampaignAB();
      };

    case "read-nav-cookie":
      return cookieRead('seen_nav');

    case "write-nav-cookie":
      writeNavCookie();
      break;

    case "write-subscribe-cookie":
      writeSubscribeCookie();
      break;

    case "read-subscribe-cookie":
      return cookieRead('subscribed');

    case "write-white-paper-cookie":
      writeWhitePaperCookie();
      break;

    case "read-white-paper-cookie":
      return cookieRead('whitePaper');

    case "write-widget-cookie":
      var cookie_data = [];
      cookie_data.push({
        landing_page_name: cookie_name,
        page_url: window.location.href,
        timestamp: Math.round(new Date().getTime() / 1000)
      });
      cookieWrite(cookie_name, expiry_utc_string, cookie_data);
  }
};

var cookieHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cmmCookieHelpers: cmmCookieHelpers
});

_objectSpread2({}, cookieHelpers);

var _excluded$c = ["value", "className", "checked", "setChecked", "label", "id", "onChange", "onFocus", "onBlur"];
var baseClass$9 = 'c-checkbox';

var ef$1 = function ef() {};

var Checkbox = function Checkbox(_ref) {
  var _classnames;

  var value = _ref.value,
      className = _ref.className,
      checked = _ref.checked,
      setChecked = _ref.setChecked,
      label = _ref.label,
      id = _ref.id,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? ef$1 : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? ef$1 : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? ef$1 : _ref$onBlur,
      rProps = _objectWithoutProperties(_ref, _excluded$c);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledChecked = _useState2[0],
      setUncontrolledChecked = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasFocus = _useState4[0],
      setHasFocus = _useState4[1];

  var checkboxId = React.useRef(id || nanoid());
  var isChecked = checked !== null && checked !== void 0 ? checked : uncontrolledChecked;
  var setIsChecked = setChecked !== null && setChecked !== void 0 ? setChecked : setUncontrolledChecked;

  var handleChange = function handleChange(event) {
    var _event$target;

    setIsChecked(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.checked);
    onChange();
  };

  var handleFocus = function handleFocus() {
    setHasFocus(true);
    onFocus();
  };

  var handleBlur = function handleBlur() {
    setHasFocus(false);
    onBlur();
  };

  var containerClass = classnames("".concat(baseClass$9), (_classnames = {}, _defineProperty(_classnames, "".concat(baseClass$9, "--has-focus"), hasFocus), _defineProperty(_classnames, "".concat(baseClass$9, "--checked"), isChecked), _classnames), className);

  var inputProps = _objectSpread2({
    className: "".concat(baseClass$9, "__field"),
    type: 'checkbox',
    id: "".concat(checkboxId.current, "_field"),
    value: value,
    checked: isChecked,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  }, rProps);

  return /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: "".concat(checkboxId.current, "_field"),
    className: containerClass
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(baseClass$9, "__control")
  }, /*#__PURE__*/React__default['default'].createElement("input", inputProps)), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-body b-body--small ".concat(baseClass$9, "__label u-color-grey-41")
  }, label));
};

var checkboxes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Checkbox: Checkbox
});

var baseClass$a = 'c-link-grid';
var LinkGrid = function LinkGrid(_ref) {
  var className = _ref.className,
      children = _ref.children,
      cellCount = _ref.cellCount;
  var gridClass = classnames(baseClass$a, _defineProperty({}, "".concat(baseClass$a, "--count-").concat(cellCount), !!cellCount), className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: gridClass
  }, children);
};

var LinkGridEyebrow = function LinkGridEyebrow(_ref2) {
  var eyebrow = _ref2.eyebrow;
  if (!eyebrow) return null;
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: "u-disp-block"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-txt-btn u-disp-inline-block u-bgc-magenta u-pad-vt-5 u-pad-hz-10 u-mar-bottom-10"
  }, eyebrow));
};

LinkGrid.Cell = function (_ref3) {
  var _classnames2;

  var href = _ref3.href,
      src = _ref3.src,
      title = _ref3.title,
      eyebrow = _ref3.eyebrow,
      fit = _ref3.fit;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var handleMouseLeave = function handleMouseLeave() {
    return setIsHovered(false);
  };

  var handleMouseEnter = function handleMouseEnter() {
    return setIsHovered(true);
  };

  var imageClass = classnames("".concat(baseClass$a, "__img"), (_classnames2 = {}, _defineProperty(_classnames2, "".concat(baseClass$a, "__img--fit"), fit), _defineProperty(_classnames2, "".concat(baseClass$a, "__img--hover"), isHovered), _classnames2));
  var cellClass = classnames('b-bare', "".concat(baseClass$a, "__cell"));
  return /*#__PURE__*/React__default['default'].createElement("a", {
    className: cellClass,
    href: href,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: imageClass,
    src: src,
    alt: ""
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "b-body b-body--large ".concat(baseClass$a, "__text u-fw-medium")
  }, /*#__PURE__*/React__default['default'].createElement(LinkGridEyebrow, {
    eyebrow: eyebrow
  }), title));
};

var linkgrid = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LinkGrid: LinkGrid
});

var _excluded$d = ["name", "children", "defaultValue"],
    _excluded2$7 = ["value", "label", "checked", "id", "onChange"];
var RadioGroupContext = /*#__PURE__*/React__default['default'].createContext({
  selectedValue: "",
  setSelectedValue: function setSelectedValue() {}
});
var RadioGroup = function RadioGroup(_ref) {
  var name = _ref.name,
      children = _ref.children,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      rProps = _objectWithoutProperties(_ref, _excluded$d);

  var _useState = React.useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  var contextValue = {
    selectedValue: selectedValue,
    setSelectedValue: setSelectedValue,
    name: name
  };
  return /*#__PURE__*/React__default['default'].createElement(RadioGroupContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React__default['default'].createElement("div", _extends({
    role: "radiogroup",
    className: "b-body"
  }, rProps), children));
};
var RadioGroupButton = function RadioGroupButton(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      checked = _ref2.checked,
      id = _ref2.id,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      rProps = _objectWithoutProperties(_ref2, _excluded2$7);

  var baseClass = 'c-radio';
  var radioId = React.useRef(id || nanoid());

  var _useContext = React.useContext(RadioGroupContext),
      selectedValue = _useContext.selectedValue,
      setSelectedValue = _useContext.setSelectedValue,
      name = _useContext.name;

  var isChecked = value === selectedValue;

  var handleChange = function handleChange(event) {
    setSelectedValue(value);
    onChange();
  };

  var inputProps = _objectSpread2({
    type: "radio",
    id: "".concat(radioId.current, "_field"),
    name: name,
    checked: isChecked,
    value: value,
    onChange: handleChange
  }, rProps);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(isChecked ? "".concat(baseClass, "__checked") : '', " c-radio__button")
  }, /*#__PURE__*/React__default['default'].createElement("label", null, /*#__PURE__*/React__default['default'].createElement("input", inputProps), /*#__PURE__*/React__default['default'].createElement("span", null, label)));
};

var radio = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RadioGroup: RadioGroup,
  RadioGroupButton: RadioGroupButton
});

var _excluded$e = ["className", "header", "children"];
var Accordion = function Accordion(_ref) {
  var className = _ref.className,
      header = _ref.header,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$e);

  var baseClass = 'c-accordion';
  var accordionClass = classnames(baseClass, className);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("details", _extends({
    className: accordionClass
  }, props), /*#__PURE__*/React__default['default'].createElement("summary", {
    className: "b-body b-body--large ".concat(accordionClass, "__header u-disp-flex")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(accordionClass, "__title")
  }, header), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(accordionClass, "__icon")
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "b-body u-mar-left-10"
  }, children)));
};

var accordion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Accordion: Accordion
});

var RenderIf = function RenderIf(_ref) {
  var conditional = _ref.conditional,
      children = _ref.children;
  if (!conditional) return null;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, children);
};

var renderif = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RenderIf: RenderIf
});

var index = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, typography), linkgrid), checkboxes), sourcelist), textbox), listbox), subscribe), stories), footer), navbars), authors), quotes), figures), mediaslider), footnotes), buttons), radio), accordion), renderif);

module.exports = index;
